<template>
  <div>
    <div class="server">
      <div class="ensure">
        <a href="javascript:void(0)"></a>
        <a href="javascript:void(0)"></a>
        <a href="javascript:void(0)"></a>
        <a href="javascript:void(0)"></a>
      </div>
      <div class="mall_desc">
        <dl v-for="(item, index) in news_list" :key="index">
          <dt>{{ item.title }}</dt>
          <dd>
            <a href="javascript:void(0)" v-for="(s_item, s_index) in item.article_list" :key="s_index">
              <router-link :to="{
                path: '/article/detail/' + s_item.id,
              }">
                {{ s_item.title }}
              </router-link>
            </a>
          </dd>
        </dl>
        <dl class="mall_mobile">
          <dt>手机商城</dt>
          <dd>
            <a href="javascript:void(0)" class="join">
              <img src="@/assets/images/mobile_qrcode.jpg" width="105" height="105" />
            </a>
          </dd>
        </dl>
        <dl class="mall_mobile">
          <dt>商城客服微信电话</dt>
          <dt>
            18820057778
          </dt>
        </dl>
      </div>
      <footer-info></footer-info>
    </div>
  </div>
</template>
<script>
  import FooterInfo from '@/components/FooterInfo.vue';
  import {
    getAllArticleList
  } from "@/api/public.js";
  export default {
    name: "Footer",
    components: {
      FooterInfo
    },
    props: {},
    data: function () {
      return {
        news_list: [],
      };
    },
    mounted: function () {
      var that = this;
      getAllArticleList().then((res) => {
        that.news_list = res.data;
      });
    },
    methods: {},
  };
</script>

<style scoped>
  .server .mall_desc {
    width: 1200px;
    padding-top: 22px;
    height: 190px;
    margin: auto;
    border-top: 1px solid #ededed;
  }
</style>
